import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ddbb8f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

import { computed } from 'vue';

interface Props {
  variant?: 'primary' | 'secondary' | 'danger' | 'warning' | 'outline' | 'ghost' | 'success';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  disabled?: boolean;
  icon?: string;
  label?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DSButton',
  props: {
    variant: { default: 'primary' },
    size: { default: 'md' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    icon: { default: '' },
    label: { default: '' }
  },
  setup(__props: any) {

const props = __props;



const isOutline = computed(() => props.variant === 'outline');
const isGhost = computed(() => props.variant === 'ghost');

const getVariantColor = computed(() => {
  if (props.variant === 'outline') return 'primary';
  if (props.variant === 'ghost') return undefined;
  if (props.variant === 'danger') return 'negative';
  if (props.variant === 'warning') return 'warning';
  if (props.variant === 'secondary') return 'secondary';
  if (props.variant === 'success') return 'positive';
  return 'primary';
});

const getSize = computed(() => {
  if (props.size === 'lg') return 'lg';
  if (props.size === 'sm') return undefined;
  return 'md';
});

const classes = computed(() => ({
  'q-px-md': props.size !== 'sm',
  'q-px-sm': props.size === 'sm',
  'ds-button': true,
  [`ds-button--${props.variant}`]: true,
  [`ds-button--${props.size}`]: true,
}));

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
    color: getVariantColor.value,
    outline: isOutline.value,
    flat: isGhost.value,
    dense: _ctx.size === 'sm',
    loading: _ctx.loading,
    disable: _ctx.disabled,
    size: getSize.value,
    "no-caps": "",
    unelevated: "",
    rounded: "",
    class: classes.value
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      (_ctx.icon && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: _ctx.icon,
            class: _normalizeClass({ 'q-mr-xs': _ctx.label })
          }, null, 8, ["name", "class"]))
        : _createCommentVNode("", true),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["color", "outline", "flat", "dense", "loading", "disable", "size", "class"]))
}
}

})